/**
 * Billing utilities for opening web billing pages
 *
 * @module @ideoz/core/utils/billingUtils
 */

import { ApiUrls } from '../api/ApiUrls';
import { getAccessToken } from './cookie.utils';


/**
 * Opens the web billing page with authentication token
 * Used in plugin contexts to redirect users to web billing
 */
export const openWebBillingWithToken = (): void => {
  // Try plugin environment first (window.appAccessToken), then fallback to cookies
  let token: string | null = null;
  
  // Plugin environment: token stored in window object
  if (typeof window !== 'undefined' && (window as any).appAccessToken) {
    token = (window as any).appAccessToken;
  } else {
    // Web environment: try getting from cookies
    try {
      token = getAccessToken();
    } catch (error) {
      console.warn('Failed to get access token from cookies:', error);
    }
  }
  
  const baseUrl = ApiUrls.platformUrl.replace(/\/api\/?$/, ''); // Remove trailing /api if present
  
  const billingUrl = token 
    ? `${baseUrl}billing?token=${encodeURIComponent(token)}`
    : `${baseUrl}billing`;
  
  window.open(billingUrl, '_blank');
};